var _defs, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "logo_svg__logo_svg__svg13",
    width: 24,
    height: 24,
    className: "logo_svg__logo_svg__d-inline-block logo_svg__logo_svg__align-top",
    viewBox: "0 0 24.308 24.308"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "logo_svg__logo_svg__defs7"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__logo_svg__linearGradient918",
    x1: 33.844,
    x2: 0,
    y1: 33.848,
    y2: -0.001,
    gradientTransform: "scale(.71822 .71815)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "logo_svg__logo_svg__stop2",
    className: "logo_svg__logo_svg__gradient-primary-stop",
    offset: 0,
    stopColor: "#4355e9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "logo_svg__logo_svg__stop4",
    className: "logo_svg__logo_svg__gradient-primary-start",
    offset: 1,
    stopColor: "#8c55ea"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "logo_svg__logo_svg__rect9",
    width: 24.308,
    height: 24.308,
    x: 0,
    y: 0,
    fill: "url(#logo_svg__logo_svg__linearGradient918)",
    strokeWidth: 1.913,
    rx: 3.946,
    ry: 3.946
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo_svg__logo_svg__path11",
    fill: "#fff",
    strokeWidth: 0.489,
    d: "M10.947 7.5a.995.995 0 00-.989 1.005v4.856a1.412 1.436 0 01-1.412 1.436 1.412 1.436 0 01-1.412-1.436.988 1.005 0 00-.99-1.004.988 1.005 0 00-.987 1.004.988 1.005 0 00.005.088 3.39 3.446 0 003.384 3.358 3.39 3.446 0 003.388-3.446V8.079a.576.576 0 00-.578-.578h-.409zm2.44 0a.579.579 0 00-.58.58v.816c0 .32.258.58.58.58h2.316c.784.001 1.42.62 1.434 1.386l.002 1.291-.002 1.292a1.424 1.424 0 01-1.433 1.386h-.72a.994.994 0 00-1.007.987c0 .548.45.99 1.006.99h.72c1.864 0 3.373-1.458 3.436-3.275h.011s-.002-.807 0-2.644v-.115h-.011C19.076 8.957 17.567 7.5 15.704 7.5h-1.502z"
  })));
};

;
export default SvgLogo;